import KpiCard from '@/components/base/KpiCard';
import ApplicationsTable from './components/ApplicationsTable';

const ApplicationsPage: React.FC = () => {
  return (
    <div>
      <div className="mb-5">
        <h1 className="text-xl font-bold text-white" style={{ fontFamily: 'Inter, sans-serif' }}>Uzman Başvuruları</h1>
        <p className="text-xs mt-0.5" style={{ color: '#6b7280' }}>Tüm başvuruları yönetin ve değerlendirin</p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-5">
        <KpiCard label="Toplam Başvuru" value={87} change={12.4} icon="ri-user-add-line" />
        <KpiCard label="Beklemede" value={32} icon="ri-time-line" />
        <KpiCard label="Onaylandı" value={31} change={-2.1} icon="ri-check-line" />
        <KpiCard label="Reddedildi" value={24} icon="ri-close-circle-line" />
      </div>

      <div
        className="rounded-xl p-5"
        style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.08)' }}
      >
        <ApplicationsTable />
      </div>
    </div>
  );
};

export default ApplicationsPage;
